import { ANSIBLE_KEY } from './constants';

export const hashRoute = subpath => `#/${ANSIBLE_KEY}/${subpath}`;
export const route = subpath => hashRoute(subpath).substring(1);



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_ansible-9.0.1-1.fm3_4.el8.noarch/usr/share/gems/gems/foreman_ansible-9.0.1/webpack/components/AnsibleHostDetail/helpers.js